import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("パスワードを更新してください")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 更新 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_MButton = _resolveComponent("MButton")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { "show-close-button": false }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "パスワードを設定",
          name: "password",
          type: "password",
          placeholder: "8文字以上の英数字・記号",
          value: _ctx.password,
          entered: _ctx.passwordEntered,
          invalid: _ctx.passwordEntered && !_ctx.isValidPassword,
          "invalid-message": "パスワードは8文字以上の英数字・記号で設定してください",
          onInput: _ctx.onPasswordInput,
          onEnter: _ctx.onPasswordBlur
        }, null, 8, ["value", "entered", "invalid", "onInput", "onEnter"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_field, {
          label: "パスワードを再入力",
          name: "password",
          type: "password",
          placeholder: "8文字以上の英数字・記号",
          value: _ctx.passwordToConfirm,
          entered: _ctx.passwordConfirmEntered,
          invalid: _ctx.passwordConfirmEntered && !_ctx.isValidPasswordConfirm,
          "invalid-message": _ctx.confirmPasswordError,
          onInput: _ctx.onConfirmInput,
          onEnter: _ctx.onConfirmBlur
        }, null, 8, ["value", "entered", "invalid", "invalid-message", "onInput", "onEnter"])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_MButton, {
        disabled: !_ctx.validDataInput,
        onClick: _ctx.commit
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }))
}